import * as React from "react";
import * as _ from "lodash";
import { useForm } from "react-hook-form";
import * as Inputs from "../common/hook-form/index";
import { ActionSpinner } from "../../components/ActionSpinner";

interface OwnProps {
  onSubmit: Function;
  onReset: Function;
}

export const BeaconListFiltersForm: React.FC<OwnProps> = (props) => {
  const methods = useForm({
    defaultValues: { filterByPosVenueRef: "" },
  });

  return (
    <form className="card">
      <div className="card-header">
        <h3 className="card-title">Search</h3>
      </div>
      <div className="card-body">
        <div className="row">
          <div className="col-md-6 col-lg-4">
            <Inputs.InputFormField
              errors={methods.formState.errors}
              register={methods.register}
              label="Pos Venue Ref"
              name="filterByPosVenueRef"
            />
          </div>
        </div>
      </div>
      <div className="card-footer text-right">
        <div className="d-flex">
          <input
            className="btn btn-link"
            type="reset"
            value="Reset"
            onClick={(e) => {
              methods.reset();
              props.onReset(e);
            }}
          />
          <button
            type="button"
            onClick={methods.handleSubmit((values: { [key: string]: any }) =>
              props.onSubmit(_.omitBy(values, (x) => x === ""))
            )}
            disabled={methods.formState.isSubmitting}
            className="btn btn-primary btn-sm ml-auto"
          >
            {methods.formState.isSubmitting ? <ActionSpinner /> : "Search"}
          </button>
        </div>
      </div>
    </form>
  );
};

export default BeaconListFiltersForm;
